// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SelectEmailFlowPopup_error_container__13Mlc {
  padding: 10px;
  margin: 0px 5px 25px 5px;
  background-color: var(--color-theme-red);
}

.SelectEmailFlowPopup_error_text__owKGE {
  font-size: 16px;
  color: var(--color-theme-white);
}
`, "",{"version":3,"sources":["webpack://./src/@_components/popups/SelectEmailFlowPopup/SelectEmailFlowPopup.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,wBAAwB;EACxB,wCAAwC;AAC1C;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC","sourcesContent":[".error_container {\n  padding: 10px;\n  margin: 0px 5px 25px 5px;\n  background-color: var(--color-theme-red);\n}\n\n.error_text {\n  font-size: 16px;\n  color: var(--color-theme-white);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"error_container": `SelectEmailFlowPopup_error_container__13Mlc`,
	"error_text": `SelectEmailFlowPopup_error_text__owKGE`
};
export default ___CSS_LOADER_EXPORT___;
